import React, { ComponentPropsWithoutRef } from 'react';

import classNames from 'classnames';

export type ConnectButtonVariant = 'primary' | 'secondary';

type ConnectWalletButtonProps = ComponentPropsWithoutRef<'button'> & {
  variant?: ConnectButtonVariant;
};

export const ConnectButton = ({
  className,
  variant = 'secondary',
  ...props
}: ConnectWalletButtonProps) => {
  return (
    <button
      type="button"
      className={classNames(`msq-btn msq-btn-lg w-[116px] msq-btn-${variant}`, className)}
      data-qa="profile-connect-button"
      {...props}
    />
  );
};
